__turbopack_context__.v({
  "closeModalButton": "DataProcessingModal-module__LNOzEq__closeModalButton",
});
